
  document.addEventListener('DOMContentLoaded', function () {
    const toggles = document.querySelectorAll('.collapsible-toggle');

    toggles.forEach(button => {
      button.addEventListener('click', () => {
        const content = button.nextElementSibling;
        const arrow = button.querySelector('.toggle-arrow');

        if (content.classList.contains('collapsed')) {
          content.classList.remove('collapsed');
          arrow.textContent = '▾';
        } else {
          content.classList.add('collapsed');
          arrow.textContent = '▸';
        }
      });
    });
  });

  const minSlider = document.getElementById('price-min');
  const maxSlider = document.getElementById('price-max');
  const minDisplay = document.getElementById('minPriceDisplay');
  const maxDisplay = document.getElementById('maxPriceDisplay');

  function syncSliders() {
    let minVal = parseInt(minSlider.value);
    let maxVal = parseInt(maxSlider.value);

    if (minVal > maxVal - 10) {
      minSlider.value = maxVal - 10;
      minVal = maxVal - 10;
    }
    if (maxVal < minVal + 10) {
      maxSlider.value = minVal + 10;
      maxVal = minVal + 10;
    }

    minDisplay.textContent = minVal;
    maxDisplay.textContent = maxVal;
  }

  if (minSlider && maxSlider) {
    minSlider.addEventListener('input', syncSliders);
    maxSlider.addEventListener('input', syncSliders);
  }





